module.exports = __webpack_public_path__ + "static/media/11.104.cb5d70b8.webp";